import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../../components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';
import { RestoreUserDialogProps } from '../types';

export function RestoreUserDialog({
  isDark,
  user,
  isRestoring,
  onOpenChange,
  onConfirm,
}: RestoreUserDialogProps) {
  return (
    <AlertDialog open={!!user} onOpenChange={(open) => !open && onOpenChange(open)}>
      <AlertDialogContent className={isDark ? 'bg-[#1A1A22] border-slate-700' : ''}>
        <AlertDialogHeader>
          <AlertDialogTitle className={isDark ? 'text-white' : ''}>
            Восстановить аккаунт {user?.email || `@${user?.username ?? ''}`}?
          </AlertDialogTitle>
          <AlertDialogDescription className={isDark ? 'text-slate-400' : ''}>
            Пользователь снова сможет войти в приложение. Его прогресс и статус подписки
            вернутся в том виде, в каком были на момент удаления.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={isRestoring}
            className={isDark ? 'border-slate-700 text-slate-300 hover:bg-slate-800' : ''}
          >
            Отмена
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={(e) => {
              e.preventDefault();
              onConfirm();
            }}
            disabled={isRestoring}
            className="bg-emerald-600 hover:bg-emerald-700"
          >
            {isRestoring && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Восстановить
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
